/**
 * Entry point — Vite mount React + i18n + TanStack Query.
 */

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./i18n";
import "./index.css";
import { queryClient } from "./lib/queryClient";

const root = document.getElementById("root");
if (!root) throw new Error("#root introuvable dans index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
